import React, { useState } from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../../components/TextField/TextField';
import Loading from '../../../../components/Loading/Loading';

//Api
import cep_api from '../../../../api/cep_api';

//Helpers
import { validarCampos } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';
import { showMessage } from '../../../../helpers/message';

export default function IdentificacaoTransportador({ transportador, errors, setErrors, setTransportador, campos }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //opções para o select de situação do transportador
    const optionsSituacao = [
        { value: "Ativo", text: "Ativo" },
        { value: "Bloqueado", text: "Bloqueado" },
        { value: "Cancelado", text: "Cancelado" },
        { value: "Inativo", text: "Inativo" },
    ]
    //onChange para o campo de cep carregando os dados assim que que preenche o cep totalmente
    const onChangeCep = (e) => {
        const { name, value } = e.target;
        const _transportador = { ...transportador, [name]: value };
        if (value.length == 8) {
            setLoading(true);
            cep_api.get(value).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _transportador.bairro = response.data.bairro;
                _transportador.uf = response.data.uf;
                _transportador.complemento = response.data.complemento;
                _transportador.logradouro = response.data.logradouro;
                _transportador.cidade = response.data.localidade;
                const erros = validarCampos(_transportador, campos);
                setErrors(erros[0]);
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base", "error", null);
            }).finally(f => {
                setTransportador(_transportador);
                setLoading(false);
            })
        } else {
            setTransportador(_transportador);
        }

    }
    //onChange para os outros campos conferindo se os obrigatorios estão vazios e mostrando erro se sim
    const onChangeTransportador = (e) => {
        const { name, value } = e.target;
        const _transportador = { ...transportador, [name]: value };

        setTransportador(_transportador);

        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_transportador, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setTransportador(_transportador);
    }

    return (
        <div className='p-2 m-2'>
            {loading && <Loading />}
            <Row>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.cnpjMask} maxLength={"18"} label={"* CNPJ"} name={"cnpj"} value={transportador.cnpj} onChange={onChangeTransportador} invalid={errors.cnpj ? true : false} />
                    {errors.cnpj && <span className={"form-control-label text-danger"}>{errors.cnpj.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"10"} label={"Inscrição"} name={"inscricao"} value={transportador.inscricao} onChange={onChangeTransportador} invalid={errors.inscricao ? true : false} />
                    {errors.inscricao && <span className={"form-control-label text-danger"}>{errors.inscricao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"* Responsável"} name={"responsavel"} value={transportador.responsavel} onChange={onChangeTransportador} invalid={errors.responsavel ? true : false} />
                    {errors.responsavel && <span className={"form-control-label text-danger"}>{errors.responsavel.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label={"* E-mail"} name={"email"} value={transportador.email} onChange={onChangeTransportador} invalid={errors.email ? true : false} />
                    {errors.email && <span className={"form-control-label text-danger"}>{errors.email.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.celularMask} maxLength={"14"} label={"* Fone"} name={"fone"} value={transportador.fone} onChange={onChangeTransportador} invalid={errors.fone ? true : false} />
                    {errors.fone && <span className={"form-control-label text-danger"}>{errors.fone.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.celularMask} maxLength={"14"} label={"Celular"} name={"celular"} value={transportador.celular} onChange={onChangeTransportador} invalid={errors.celular ? true : false} />
                    {errors.celular && <span className={"form-control-label text-danger"}>{errors.celular.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"50"} label={"* Fantasia"} name={"fantasia"} value={transportador.fantasia} onChange={onChangeTransportador} invalid={errors.fantasia ? true : false} />
                    {errors.fantasia && <span className={"form-control-label text-danger"}>{errors.fantasia.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label={"* Razão social"} name={"razao"} value={transportador.razao} onChange={onChangeTransportador} invalid={errors.razao ? true : false} />
                    {errors.razao && <span className={"form-control-label text-danger"}>{errors.razao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.numeroMask} maxLength={"30"} label={"* Número do processo"} name={"numeroProcesso"} value={transportador.numeroProcesso} onChange={onChangeTransportador} invalid={errors.numeroProcesso ? true : false} />
                    {errors.numeroProcesso && <span className={"form-control-label text-danger"}>{errors.numeroProcesso.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Situação"} name={"situacao"} value={transportador.situacao} onChange={onChangeTransportador} type={"select"} options={optionsSituacao} invalid={errors.situacao ? true : false} />
                    {errors.situacao && <span className={"form-control-label text-danger"}>{errors.situacao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset" className='mt-2'>
                        <legend className='label'>Realizar Coleta Avulsa?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="naoRealizaColetaAvulso" onChange={onChangeTransportador} value={"true"} checked={transportador.naoRealizaColetaAvulso?.toString() == "true"} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="naoRealizaColetaAvulso" onChange={onChangeTransportador} value={"false"} checked={transportador.naoRealizaColetaAvulso?.toString() == "false"} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.naoRealizaColetaAvulso && <span className={"form-control-label text-danger"}>{errors.naoRealizaColetaAvulso.message}</span>}
                    </FormGroup>
                </Col>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset" className='mt-2'>
                        <legend className='label'>Utiliza QRCODE na Coleta?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="realizaColetaPorQRCode" onChange={onChangeTransportador} value={"false"} checked={transportador.realizaColetaPorQRCode?.toString() == "false"} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="realizaColetaPorQRCode" onChange={onChangeTransportador} value={"true"} checked={transportador.realizaColetaPorQRCode?.toString() == "true"} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.realizaColetaPorQRCode && <span className={"form-control-label text-danger"}>{errors.realizaColetaPorQRCode.message}</span>}
                    </FormGroup>
                </Col>

            </Row>
            <Row>
                <Col md="12" lg="4">
                    <FormGroup tag="fieldset" className='mt-2'>
                        <legend className='label'>Divulgar na Internet?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="divulgarInternet" onChange={onChangeTransportador} value={"Não"} checked={transportador.divulgarInternet === "Não" ? true : false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="divulgarInternet" onChange={onChangeTransportador} value={"Sim"} checked={transportador.divulgarInternet === "Sim" ? true : false} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.divulgarInternet && <span className={"form-control-label text-danger"}>{errors.divulgarInternet.message}</span>}
                    </FormGroup>
                </Col>
            </Row>
            <h5 className='my-3'><FontAwesomeIcon className='me-3' icon={faFile} />Credenciamento</h5>
            <Row>
                <Col md="12" lg="6">
                    <TextField maxLength={"15"} label={"Número de credenciamento"} name={"credenciamentoNumero"} value={transportador.credenciamentoNumero} onChange={onChangeTransportador} invalid={errors.credenciamentoNumero ? true : false} />
                    {errors.credenciamentoNumero && <span className={"form-control-label text-danger"}>{errors.credenciamentoNumero.message}</span>}
                </Col>
                <Col md="12" lg="6">
                    <TextField label={"* Validade do credenciamento"} type={"date"} name={"credenciamentoValidade"} value={transportador.credenciamentoValidade} onChange={onChangeTransportador} invalid={errors.credenciamentoValidade ? true : false} />
                    {errors.credenciamentoValidade && <span className={"form-control-label text-danger"}>{errors.credenciamentoValidade.message}</span>}
                </Col>

            </Row>
            <Row>
                <Col md="12" lg="6">
                    <TextField maxLength={"15"} label={"Número licença da operação"} name={"operacaoNumero"} value={transportador.operacaoNumero} onChange={onChangeTransportador} invalid={errors.operacaoNumero ? true : false} />
                    {errors.operacaoNumero && <span className={"form-control-label text-danger"}>{errors.operacaoNumero.message}</span>}
                </Col>
                <Col md="12" lg="6">
                    <TextField label={"* Validade da licença"} type={"date"} name={"operacaoValidade"} value={transportador.operacaoValidade} onChange={onChangeTransportador} invalid={errors.operacaoValidade ? true : false} />
                    {errors.operacaoValidade && <span className={"form-control-label text-danger"}>{errors.operacaoValidade.message}</span>}
                </Col>
            </Row>
            <h5 className='my-3'><FontAwesomeIcon className='me-3' icon={faMapMarkerAlt} />Endereço</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.cepMask} maxLength={"9"} label={"* CEP"} name={"cep"} value={transportador.cep} onChange={onChangeCep} invalid={errors.cep ? true : false} />
                    {errors.cep && <span className={"form-control-label text-danger"}>{errors.cep.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"* Cidade"} name={"cidade"} value={transportador.cidade} onChange={onChangeTransportador} invalid={errors.cidade ? true : false} />
                    {errors.cidade && <span className={"form-control-label text-danger"}>{errors.cidade.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"2"} label={"UF"} name={"uf"} value={transportador.uf} onChange={onChangeTransportador} invalid={errors.uf ? true : false} />
                    {errors.uf && <span className={"form-control-label text-danger"}>{errors.uf.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"* Bairro"} name={"bairro"} value={transportador.bairro} onChange={onChangeTransportador} invalid={errors.bairro ? true : false} />
                    {errors.bairro && <span className={"form-control-label text-danger"}>{errors.bairro.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"150"} label={"* Logradouro"} name={"logradouro"} value={transportador.logradouro} onChange={onChangeTransportador} invalid={errors.logradouro ? true : false} />
                    {errors.logradouro && <span className={"form-control-label text-danger"}>{errors.logradouro.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"10"} label={"* Número"} name={"numero"} value={transportador.numero} onChange={onChangeTransportador} invalid={errors.numero ? true : false} />
                    {errors.numero && <span className={"form-control-label text-danger"}>{errors.numero.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Complemento"} name={"complemento"} value={transportador.complemento} onChange={onChangeTransportador} invalid={errors.complemento ? true : false} />
                    {errors.complemento && <span className={"form-control-label text-danger"}>{errors.complemento.message}</span>}
                </Col>
            </Row>
        </div>
    )
}